import * as classes from "./picture-nice-loader.module.scss";
import classNames from "classnames";
import { FC, useState } from "react";
import Spinner from "../Spinner/Spinner";

interface Source {
  srcSet: string;
  type: "image/webp" | "image/jpeg" | "image/png";
  media?: string;
}

interface Props {
  className: string;
  sizes: string;
  alt: string;
  src: string;
  sources?: Source[];
  hasLoadingSpinner?: boolean;
  width?: string | number;
  height?: string | number;
}

const PictureNiceLoader: FC<Props> = ({
  className,
  sizes,
  alt,
  src,
  sources = [],
  hasLoadingSpinner = false,
  width,
  height,
}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  return (
    <picture>
      {hasLoadingSpinner && !isLoaded ? (
        <Spinner className={classes["loading-spinner"]} />
      ) : null}
      {sources.map((attributes, index) => {
        return <source key={index} {...attributes} sizes={sizes} />;
      })}
      <img
        className={classNames(
          className,
          classes.root,
          {
            [classes["root--loaded"]]: isLoaded,
          },
          className
        )}
        src={src}
        alt={alt}
        onLoad={() => {
          requestAnimationFrame(() => {
            setIsLoaded(true);
          });
        }}
        width={width}
        height={height}
      />
    </picture>
  );
};

export default PictureNiceLoader;
